import {Component, OnInit, Output, EventEmitter, Input, OnChanges, SimpleChanges} from '@angular/core';
import {PageSearchService, PageSearch} from '../services/page-selection.service';
import {BehaviorSubject} from 'rxjs';
import {debounceTime, filter} from 'rxjs/operators';

@Component({
    selector: 'app-page-selection',
    templateUrl: './page-selection.component.html',
    styleUrls: ['./page-selection.component.scss'],
    standalone: false
})
export class PageSelectionComponent implements OnInit, OnChanges {
  pages = [];
  dropdownPage = false;
  inputChange$ = new BehaviorSubject('');

  @Input() page;
  @Input() type;
  @Input() name;
  @Output() pageChange = new EventEmitter<PageSearch>();
  @Output() resetPageId = new EventEmitter();

  constructor(private pageService: PageSearchService) {}

  ngOnInit(): void {
    this.inputChange$
      .pipe(
        filter(value => value?.length > 2),
        debounceTime(300),
      )
      .subscribe(() => {
        this.getPages();
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.page) {
      this.name = changes.page.currentValue ? changes.page.currentValue.name : '';
    }
  }

  onInputChange(value) {
    this.inputChange$.next(value);
  }

  getPages(type = null) {
    if (this.name.length > 2) {
      const params = {};
      params['search_phrase'] = this.name;
      if (type) {
        params['types'] = [type];
      } else if (this.type) {
        params['types'] = [this.type];
      }
      this.pageService.getPages(params).subscribe((response: any) => {
        this.pages = response.results;
      });
      this.dropdownPage = true;
    } else {
      this.dropdownPage = false;
    }
  }

  getPageDetails(uuid) {
    this.pageService.getPageDetails(uuid).subscribe(e => (this.page = e));
  }

  setPage(page) {
    this.dropdownPage = false;
    this.name = page.name;
    this.page = page;
    this.pageChange.emit(page);
  }

  resetPage() {
    this.name = '';
    this.page = '';
    this.resetPageId.emit();
  }
}
